import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfiniteScroll from 'react-infinite-scroll-component';
import { styled } from 'styled-components';
import Button from '../../Controls/Button/index.js';
const Div = styled.div `
  text-align: center;
  margin-top: 15px;
`;
const InfiniteScrollComponent = ({ next, hasMore, loading, children, dataLength, loadMoreLabel, scrollThreshold = 0.6, scrollableTarget, }) => (_jsxs(InfiniteScroll, { next: next, hasMore: hasMore, loader: _jsx("span", {}), scrollThreshold: scrollThreshold, 
    // Wrong type in the package: https://github.com/ankeetmaini/react-infinite-scroll-component/issues/378
    scrollableTarget: scrollableTarget, dataLength: dataLength, style: {
        overflow: 'visible',
    }, children: [children, hasMore && (_jsx(Div, { children: _jsx(Button, { disabled: loading, isLoading: loading, onClick: next, variant: 'create-secondary', inline: true, children: loadMoreLabel }) }))] }));
export default InfiniteScrollComponent;
